import store from "@/store";
import personasStatuses from "@/config/personas-statuses";
import isTokenValid from "@/utils/validation/is-token-valid";
import authenticationRoutes from "../routes/authentication";

export default async function getDestination({ to }) {
  let redirectTo = to.name

  const hasValidToken = isTokenValid()

  const user = hasValidToken ? await getUser() : null

  const isAuthRoute = authenticationRoutes.find((route) => route.name === to.name)

  const requireAuth = to.matched.some((record) => record.meta.requireAuth)

  if (isAuthRoute && hasValidToken) redirectTo = checkIfUserHasAccessToTargetRoute({ to, user }) ? "home-page" : "overview"

  if (requireAuth && !hasValidToken) redirectTo = "login"

  return redirectTo
}

async function getUser() {
  const user = Object.keys(store.state.User.user).length ? store.state.User.user : null

  if (!user) {
    try {
      await store.dispatch("User/fetchUser", { fetchDependencies: true })
      return { ...store.state.User.user }
    } catch (error) {
      return null
    }
  }
  return user
}

function checkIfUserHasAccessToTargetRoute({
  to,
  user,
}) {
  return !!(personasStatuses[user.persona]
    && personasStatuses[user.persona][user.status]
    && !personasStatuses[user.persona]?.[user.status]?.availableRoutes.includes(to.name));
}
